import { EP } from "../configs/constant";
import { getPath } from "../helpers/handleUrl";
import { IProductResponse } from "../types/product";
import axiosService, { AxiosService } from "./axiosConfig";
class ProductService {
    readonly service: AxiosService;
    constructor() {
        this.service = axiosService;
    }
    getProducts() {
        return this.service.get<IProductResponse>(getPath(EP.PRODUCT, EP.LIST))
    }
}
const productNewService = new ProductService();
export default productNewService;